import React from "react";
import Grid from "@mui/material/Grid";
import { display } from "@mui/system";
import { Box, Button, Typography } from "@mui/material";
import { Formik } from "formik";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import * as Yup from "yup";
import { CountdownCmp } from "../countdown/Countdown";
import {
  ActivateLoanRequestBySupplierResponse,
  ReferenceKeyRequest,
} from "../../models/loan.model";
import { HandleNext } from "../../models/sharedFunctions";
import { useMutation, useQueryClient } from "react-query";
import {
  activateLoanRequestBySupplier,
  sendLoanActivationCodeToCustomer,
} from "../../services/loan.service";
import {
  REFERENCE_KEY,
  VALID_FORM,
  VALUES_CONFIRM_FACILITY,
} from "../../config/cacheKey";
import { useHistory } from "react-router-dom";
import ModalCmp from "../modals/ModalCmp";
import Modal from "@mui/material/Modal";
import { ApiResultModel } from "../../models/common.model";


export default function FacitlityActivationCmp({ handleNext }: HandleNext) {
  const queryClient = useQueryClient();
  const history = useHistory();
  const [selectedCount, setSelectedPart] = React.useState();
  const [open, setOpen] = React.useState<boolean>(false);
  const [openBlueModal, setOpenBlueModal] = React.useState(false);
  const [loanRequestId, setLoanRequestId] = React.useState(0);
  const [openValidationModel, setOpenValidationModel] = React.useState(false);
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  const [validationMessages, setValidationMessages] = React.useState<string[]>(
    []
  );
  const handleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if (
      event.target.value.length >= yupVerificationMax &&
      key != 8 &&
      key != 46 && selectedCount === 0
    ) {
      event.preventDefault();
    }
  };
  const yupVerificationMax = 5;
  const validateVerificationCode = Yup.object().shape({
    activationOtp: Yup.string()
      .required("کد فعالسازی اجباری است")
      .matches(/^[0-9]+$/, "کد فعالسازی فقط عدد می باشد.")
      .min(yupVerificationMax, "کد قعال سازی 5 رقم است")
      .max(yupVerificationMax, "کد فعال سازی 5 رقم است"),
  });
  const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const activateLoanRequestBySupplierMutation = useMutation(
    activateLoanRequestBySupplier,
    {
      onSuccess: (data: ApiResultModel<ActivateLoanRequestBySupplierResponse>) => {
        setOpenBlueModal(false);
        setOpenValidationModel(false);
        if (data.isSuccess) {
          if (data.data.isValid) {
            queryClient.setQueryData(VALID_FORM, data.data.isValid);
            queryClient.setQueryData(REFERENCE_KEY, "");
            setLoanRequestId(data.data.loanRequestId);
            setOpenBlueModal(true);
            history.push("/loan/SupplierSettlementCartable");
            // history.push("/loan/loan-list");
          } else {
            setValidationMessages(data.data.validationIssues);
            setOpenValidationModel(true);
            setSubmitFlag(true);
            setOpen(false);
          }
        } else if (!data.isSuccess) {
          setSubmitFlag(true);
          setOpen(false);
        }
      },
      onError: () => {
        setSubmitFlag(true);
      },
    }
  );
  const sendLoanActivationCodeToCustomerMutation = useMutation(
    sendLoanActivationCodeToCustomer,
    {
      onSuccess: (data: boolean) => {
        if (data) {
        }
      },
    }
  );
  const referenceKey = new ReferenceKeyRequest();
  referenceKey.referenceKey = queryClient.getQueryData(REFERENCE_KEY);
  function handleOnCompletedClick() {
    sendLoanActivationCodeToCustomerMutation.mutate(referenceKey);
  }

  const handelVerify = () => {
    const value = queryClient.getQueryData<ReferenceKeyRequest>(
      VALUES_CONFIRM_FACILITY
    );
    if (referenceKey.referenceKey) {
      activateLoanRequestBySupplierMutation.mutate(value!);
    }
  };
  const handelCancel = () => {
    handleClose();
  };
  const handleClose = () => {
    setOpen(false);
  };
  const currentSelection = (e: any) => {
    setSelectedPart(e.target.value.substring(e.target.selectionStart, e.target.selectionEnd).length);
  }

  return (
    <div className="mTop40 mbottom20">
      <Typography style={{ color: "#000000", textAlign: "center" }}>
        با وارد کردن رمز فعالسازی و فشردن دکمه <b>"فعالسازی تسهیلات"</b>،
        درخواست اعطای تسهیلات برای تامین کننده مالی تسهیلات ارسال خواهد شد.
      </Typography>

      <Formik
        initialValues={new ReferenceKeyRequest()}
        validateOnMount={true}
        validationSchema={validateVerificationCode}
        onSubmit={(values) => {
          // if (submitFlag) {
          // setSubmitFlag(false);
          values.referenceKey = queryClient.getQueryData(REFERENCE_KEY);
          // activateLoanRequestBySupplierMutation.mutate(values);
          queryClient.setQueryData(VALUES_CONFIRM_FACILITY, values);
          setOpen(true);

          // }
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
        }) => (
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
            style={{
              justifyContent: "center",
              display: "flex",
              alignContent: "center",
            }}
            className="mTop30"
          >
            <Grid
              container
              spacing={1}
              style={{
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid
                container
                item
                spacing={1}
                style={{
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid item xs={4} md={4} sm={4}></Grid>
                <Grid item xs={4} md={4} sm={4}>
                  <MaterialTextFieldComponent
                    autoFocus={true}
                    helperText={
                      touched.activationOtp ? errors.activationOtp : ""
                    }
                    error={
                      touched.activationOtp && Boolean(errors.activationOtp)
                    }
                    placeHolder={"رمز فعالسازی"}
                    label={"رمز فعالسازی "}
                    required={true}
                    value={values.activationOtp}
                    onChange={handleChange}
                    name="activationOtp"
                    id="activationOtp"
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    onSelect={currentSelection}
                  />
                </Grid>
                <Grid item xs={4} md={4} sm={4}>
                  <Typography className=" iranSans-font  colorOk textFont15 fontWeight ">
                    <CountdownCmp
                      countDownValue={120000}
                      onCompletedClick={() => handleOnCompletedClick()}
                      btnName="ارسال مجدد کد فعالسازی"
                    />
                  </Typography>
                  {/* <Button style={{ color: "#01AF43" }}>ارسال مجدد کد فعالسازی</Button> */}
                </Grid>
              </Grid>
              <Grid
                container
                item
                spacing={1}
                style={{
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid item xs={4} md={4} sm={4}></Grid>
                <Grid item xs={4} md={4} sm={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    type="submit"
                    disabled={Object.keys(errors).length > 0}
                    className={`${Object.keys(errors).length > 0
                        ? "btnForm disabledBtn "
                        : "btnForm SuccessDefault"
                      }`}
                    style={{ marginTop: "25px" }}
                  >
                    فعالسازی تسهیلات
                  </Button>
                </Grid>
                <Grid item xs={4} md={4} sm={4}></Grid>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box
            sx={style}
            style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
            className="ModalCmp textCenter "
          >
            <div>
              <Typography className="textCenter mTop30 mbottom20">
                با تایید این گزینه <b>اعطای تسهیلات</b> نهایی شده و{" "}
                <b>جدول اقساط</b> تشکیل خواهد شد
              </Typography>
            </div>
            <Grid container spacing={2} columns={16} className="mTop20">
              <Grid item xs={8}>
                <Button
                  onClick={handelVerify}
                  fullWidth
                  className="btnForm SuccessDefault"
                >
                  می پذیرم
                </Button>
              </Grid>
              <Grid item xs={8}>
                <Button
                  onClick={handelCancel}
                  fullWidth
                  className="btnForm DangerDefault"
                >
                  فعلا نه
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        <ModalCmp
          openModel={openValidationModel}
          validationMessages={validationMessages}
          firstPartOfTitle=" درخواست تسهیلات به دلایل زیر"
          boldTitle="پذیرفته"
          secondPartOfTitle="نشد:"
        />
      </div>
    </div>
  );
}
